import { ThreeCircles } from 'react-loader-spinner';

export const defaultSpinner = <ThreeCircles wrapperClass='spinner'   outerCircleColor="#7e6d6d" innerCircleColor="grey" middleCircleColor="#7e6d6d"/>
